module.exports = __webpack_public_path__ + "static/media/w40001.abf751c6.png";